module.exports = __webpack_public_path__ + "index_pc/img/cate_4-5.c055554f.png";